import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom'
import { DotLoader } from 'halogenium';
import { httpClient } from "./../../utils/HttpClient";
import {
  AUTHENTICATED,
  AUTHENTICATING,
  AUTHEN_ERROR
} from "../../actions/auth.action";

const queryString = require('query-string');

class OAuthCallback extends Component {
  constructor() {
    super();

    this.state = {
      authenStatus: 'Authenticating' //Authenticating, Authenticated, Error
    }
  }

  async componentDidMount() {
    const queryParams = queryString.parse(this.props.location.search);

    this.props.dispatch(userAuthenticating());
    
    const response = await httpClient.post(`/api/authentication/generate-token`, {
      code: queryParams.code,
      state: queryParams.state,
    });

    //Save Token
    if(response.status === 201)  {
      const token = response.data

      localStorage.setItem("token", token)
      const user = jwt_decode(token);
      this.props.dispatch(setCurrentUser(user));
      localStorage.setItem('user_profile',JSON.stringify(user));

      this.setState({ authenStatus: 'Authenticated' });
    } else {
      this.props.dispatch(authenFail(response));
      this.setState({ authenStatus: 'Error' });
    }
  }

  render()  {
    if(this.state.authenStatus === 'Authenticating') {
      //Setting up the user
      return (
        <div className="loading-wrapper">
          <DotLoader color="#0099FF" size="60px" margin="4px"/>
          <div className="mt-4 h5 text-primary">กำลังเข้าสู่ระบบ E-meeting ...</div>
        </div>
      )
    } else if(this.state.authenStatus === 'Error') {
      //if error exist, take the user back to login
      return <Redirect to="/" />
    } 
    
    // Authentication success
    return <Redirect to="/meeting" />;
  }
}

//Authenticating
export const userAuthenticating = () => {
  return {
    type: AUTHENTICATING,
  }
}

// Authen success, Set logged in user
export const setCurrentUser = user => {
  return {
    type: AUTHENTICATED,
    payload: user
  };
};

//Authentication Fail
export const authenFail = error => {
  return {
    type: AUTHEN_ERROR,
    payload: error
  }
}

export default connect()(OAuthCallback);